import cn from "classnames";
import Typography from "@mui/material/Typography";

import { TrackingLogic } from "@/src/logic";

import styles from "./VariantTestingPanel.module.scss";

interface VariantTestingPanelProps {
  selectedElement?: HTMLElement | null;
}

function VariantTestingPanel({ selectedElement }: VariantTestingPanelProps) {
  const { pageId, dynamicSectionId, sectionId, sectionType, componentId, componentType, pathToElement } = TrackingLogic.deconstructComponentId(
    selectedElement?.getAttribute("component-id")
  );

  if (!pageId || !dynamicSectionId || !sectionId || !sectionType || !componentId || !componentType || !pathToElement) {
    return (
      <div className={styles.container}>
        <Typography>Turn on element selector and hover over a component to begin</Typography>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={cn(styles.group, styles.column)}>
        <Typography
          variant="body2"
          className={styles.label}
        >
          Item Canonical:
        </Typography>
        <pre className={styles.pre}>
          <code>{selectedElement?.getAttribute("component-id")}</code>
        </pre>
      </div>
      <div className={styles.group}>
        <Typography
          variant="body2"
          className={styles.label}
        >
          Item Key:
        </Typography>
        <Typography
          variant="body1"
          className={styles.value}
        >
          {pathToElement}
        </Typography>
      </div>
      <div className={styles.group}>
        <Typography
          variant="body2"
          className={styles.label}
        >
          Item Id:
        </Typography>
        <Typography
          variant="body1"
          className={styles.value}
        >
          {componentId}
        </Typography>
      </div>
    </div>
  );
}

export default VariantTestingPanel;
